import React, {useMemo} from 'react';
import {useTranslation, I18nextProvider} from 'react-i18next';
import {useSelector} from 'react-redux';
import * as css from './ETicket.css';
import TicketCardCarousel from './TicketCardCarousel/TicketCardCarousel';
import TicketCard from './TicketCard/TicketCard';
import TicketMenue from './TicketMenue/TicketMenue';
import {useETicketPages} from './hooks/useETicketPages';
import {RootState} from '../../redux/store.type';
import {DEFAULT_LANG} from '../../globalVariables/locals';

function ETicket() {
    const {i18n} = useTranslation('eTicket');
    const {pages} = useETicketPages();
    const data = useSelector((state: RootState) => state.eTicket.data);
    const lang = data?.order?.lang ?? data?.lang ?? DEFAULT_LANG;
    const isHe = lang === 'he';
    const dir = isHe ? 'rtl' : 'ltr';
    const i18nLang = isHe ? 'he' : 'en';
    const scopedI18n = useMemo(() => i18n.cloneInstance({lng: i18nLang}), [i18n, i18nLang]);

    return (
        <I18nextProvider i18n={scopedI18n}>
            <css.stage $bgColor={data?.event?.imageColors?.[0]} dir={dir} data-cy="entrance-ticket-page">
                {['l1', 'l2', 'l3'].map(layer => (
                    <css.starLayer key={layer} className={layer} aria-hidden />
                ))}
                <TicketCardCarousel overlay={<TicketMenue />}>
                    {pages.map(({key, withLink, hasFooter, TopComp, topProps, Comp, props}) => (
                        <TicketCard
                            key={key}
                            top={TopComp ? <TopComp {...(topProps ?? {})} /> : null}
                            withLink={withLink}
                            hasFooter={hasFooter}>
                            {Comp ? <Comp {...props} /> : null}
                        </TicketCard>
                    ))}
                </TicketCardCarousel>
            </css.stage>
        </I18nextProvider>
    );
}

export default ETicket;
